import download from 'downloadjs'
import request from '@/modules/base/util/request'
import config from 'config'
import invoiceConfig from '../invoice/config'
import { BankTransferRequestModel, BankTransferFormModel } from '@/modules/banking/models'

export const CreditNoteService = {
  /**
   * updates creditNote.notes
   *
   * @param id number creditNote.id
   * @param notes string creditNote.notes
  */
  updateNotes: (id, notes) => {
    return request(`${invoiceConfig.cancellationUrl}/${id}/notes`, {
      auth: true,
      method: 'PUT',
      data: { notes },
    })
  },

  /**
   * downloads creditNote pdf
   *
   * @param id number creditNote.id
   * @param number string creditNote.number
  */
  downloadPdf: (id, number) => {
    return request(`${invoiceConfig.cancellationUrl}/${id}/document`, { isConcurrent: true, auth: true, method: 'POST' })
      .then((response) => {
        const { path } = response.body.data
        request(config.imageResourceHost + path, {
          responseType: 'arraybuffer',
          isConcurrent: true,
          headers: {
            'Content-Type': 'application/pdf',
          },
        }).then((response) => {
          download(response.body, `Gutschrift ${number}.pdf`, 'application/pdf')
        })
      })
  },

  createBankTransferRequestData: (booking) => {
    const {
      accountHolder,
      bookingAmount: amount,
      bookingDate: executionDate,
      purposeDescription,
      bankAccountId,
      iban,
      bic,
    } = booking

    return new BankTransferRequestModel({
      accountHolder,
      iban,
      bic,
      executionDate,
      purposeDescription,
      amount,
      bankAccountId,
    })
  },

  createBankTransferFormData: (creditNote) => {
    let accountHolder = ''
    let bic = ''
    let iban = ''
    const {
      number: usage,
      outstandingAmount: amount,
      customer: {
        name: payee,
        bankAccounts,
      },
    } = creditNote
    if (bankAccounts?.length) [{ accountHolder, bic, iban }] = bankAccounts

    return new BankTransferFormModel({
      amount: amount * -1,
      bic,
      iban,
      payee: accountHolder || payee,
      usage,
    })
  },

  syncState: (creditNoteId) => {
    return request(`${invoiceConfig.creditNoteUrl}/${creditNoteId}/state/sync`, {
      method: 'PUT',
      auth: true,
    })
  },

  getXCreditNote: (cancellationId) => {
    return new Promise((resolve, reject) => {
      request(`${invoiceConfig.cancellationUrl}/${cancellationId}/x-invoice`, {
        method: 'GET',
        auth: true,
        isConcurrent: true,
      })
        .then(response => {
          const { body: { data } } = response
          resolve(data)
        })
        .catch(reject)
    })
  },
}
